import EnhancedAdTable from './EnhancedAdTable/EnhancedAdTable';

const EnhancedAdTableDirective = (
  reactDirective,
  $state,
  AdMarkupService,
  CurrentUserService,
  FlashService
) => {
  return reactDirective(
    EnhancedAdTable,
    undefined,
    {
      restrict: 'E'
    },
    { $state, AdMarkupService, CurrentUserService, FlashService }
  );
};

EnhancedAdTableDirective.$inject = [
  'reactDirective',
  '$state',
  'AdMarkupService',
  'CurrentUserService',
  'FlashService'
];

export default EnhancedAdTableDirective;
